module.exports = __webpack_public_path__ + "static/media/video1.bb213e22.jpg";